<template>
<div class="register-step-1">
	<div class="row">
		<div class="col-sm-12 margin-bottom-40" v-if="unknownError">
			<div class="text-left text-danger">
				<a href="/register" class="text-danger without-decoration">
					{{unknownError}}
				</a>
			</div>
		</div>
	</div>

	<div class="margin-top-20 margin-bottom-20">
		<div class="row margin-bottom-20" v-if="role === 'organizer'">
			<div class="form-group col-sm-12">
				<div class="hh-checkbox">
				<input id="is_for_business" type="checkbox" v-model="formData.is_for_business">
					<label for="is_for_business" class="margin-left-10 is-for-business" label="Is for business checkbox">
						Is this for a business?
					</label>
					
				</div>
			</div>
		</div>

		<div class="row" v-if="formData.is_for_business">
			<div class="form-group col-sm-12">
				<input-label type="text"
							css-class="form-control"
							v-model="formData.business_name"
							placeholder="Legal Business Name"
							autocomplete="nope"
							:required="false"/>
				<div v-if="hasErrors">
					<div class="invalid-feedback-red" v-if="registerStepErrors.has('business_name')">
						{{registerStepErrors.get('business_name')}}
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="form-group col-sm-6">
				<input-label type="text" css-class="form-control" id="first_name" v-model="formData.first_name"
								placeholder="First Name" autocomplete="nope" :required="true"/>
				<div v-if="hasErrors">
					<div class="invalid-feedback-red" v-if="registerStepErrors.has('first_name')">
						{{registerStepErrors.get('first_name')}}
					</div>
				</div>
			</div>

			<div class="form-group col-sm-6">
				<input-label type="text" css-class="form-control" id="last_name" v-model="formData.last_name"
								placeholder="Last Name" autocomplete="nope" required/>
				<div v-if="hasErrors">
					<div class="invalid-feedback-red" v-if="registerStepErrors.has('last_name')">
						{{registerStepErrors.get('last_name')}}
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-if="!isRegisteredUsingSocialMedia">
			<div class="form-group col-sm-12 password-step-1">
				<password-container
						v-model="formData.password"
						autocomplete="nope"
						placeholder="Enter Password"
						label="Password"
						:required="true"
						:withLabel="true"
						:role="role"/>
				<div v-if="hasErrors">
					<div class="invalid-feedback-red" v-if="registerStepErrors.has('password')">
						{{registerStepErrors.get('password')}}
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-if="!isRegisteredUsingSocialMedia">
			<div class="form-group col-sm-12">
				<password-container
						v-model="formData.password_confirmation"
						autocomplete="nope"
						label="Confirm password"
						placeholder="Confirm password"
						:required="true"
						:show-hint="false"
						:withLabel="true"/>
			</div>
		</div>
		
			<div class="row">
				<div class="form-group col-sm-12">
					<input-label type="tel" css-class="form-control" id="phone" v-model="formData.phone"
						:placeholder="'Phone number (optional)'" :required="false"/>
					<div v-if="hasErrors">
						<div class="invalid-feedback-red" v-if="registerStepErrors.has('phone')">
							{{registerStepErrors.get('phone')}}
						</div>
					</div>
				</div>
			</div>

			<div class="row" v-if="role === 'organizer' && !formData.is_for_business">	
				<div class="form-group col-sm-12">
					<form-date
							v-model="formData.date_of_birth"
							:errors="getDateOfBirthErrors()"
							@setStatus="setDateOfBirthStatus"
							:edit-mode="true"
							:with-label="true"/>
					<div class="invalid-feedback-red" v-if="registerStepErrors.date_of_birth">
						{{registerStepErrors.get('date_of_birth')}}
					</div>
				</div>
			</div>
			
			<div class="profile-image-section" ref="profileImage">
				<div class="row">
					<div class="col-sm-12">
						<p class="text-left text-normal profile-picture-label">
							Profile Picture <i>(optional)</i>
						</p>
					</div>

				</div>
				<div class="row profile-image-container">
					<div class="col-sm-6 margin-top-20 margin-bottom-20">
						<image-upload ref="profileImageComponent"
						              :image-src="profile_image_url"
						              @componentLoading="componentLoading"
						              @imageUpdated="imageUpdated"
						              imageType="profileImage"
						              field="profile_image"
						/>
					</div>
				</div>
			</div>

			<form action="#" @submit.prevent="submitForm" class="form">
				<div class="row">
					<div class="col-sm-12">
						<vue-recaptcha
								ref="recaptcha"
								@verify="onCaptchaVerified"
								@expired="onCaptchaExpired"
								:sitekey="recaptchaSiteKey"
								size="mobile"
								class="g-recaptcha">
						</vue-recaptcha>
						<div v-if="hasErrors">
							<div class="invalid-feedback-red" v-if="registerStepErrors.has('recaptcha_token')">
								{{registerStepErrors.get('recaptcha_token')}}
							</div>
						</div>
					</div>
				</div>

				<div class="row hh-form-btn-wrapper margin-bottom-20 margin-top-20">
					<div class="form-group col-sm-6">
						<button type="button" v-on:click="cancelAction"
								class="btn hh-btn cancel-btn" name="Cancel">
							Cancel
						</button>
					</div>
					<div class="form-group col-sm-6">
						<button type="submit" :disabled="loading || isFormInvalid"
								class="btn save-btn hh-btn-green" name="Save and continue">
							Save and continue
						</button>
					</div>
				</div>

				<div class="form-group row form-agreement-text">
					<div class="col-sm-12">
						<p class="text-center account-agreement">
							By registering your account, you agree to our <a href="/terms" target="_blank">Services Agreement</a> and
							the
							<a href="https://stripe.com/connect-account/legal" target="_blank" rel="noopener">Stripe Connected Account Agreement</a>.
						</p>
					</div>
				</div>
			</form>
		</div>
</div>
</template>

<script>
	import {mapGetters} from 'vuex'
	import PasswordContainer from '../../../components/form/elements/PasswordContainer'
	import InputLabel from '../../../components/form/elements/InputLabel'
	import ProfileImage from '../../../components/form/ProfileImage'
	import FormDate from '../../../components/form/elements/FormDate'
	import VueRecaptcha from 'vue-recaptcha'
	import constants from '../../../config'
	import ImageUpload from '../../../components/form/ImageUpload'
	export default {
		name: 'Step-1',

		components: {
			PasswordContainer,
			InputLabel,
			ProfileImage,
			ImageUpload,
			FormDate,
			'vue-recaptcha': VueRecaptcha,
		},

		props: {
			userData: {
				email: String,
				first_name: String,
				last_name: String,
				business_name: String,
				phone: String,
				date_of_birth: Date,
				profile_image: String,
			},

			config: Object,
			userRoles: Array,
			identities: Array,
		},

		data: () => {
			return {
				loading: true,
				recaptchaSiteKey: null,
				profileImageEndpoint: null,
				isDateOfBirthValid: true,
				profile_image_url: null,
				formData: {
					email: null,
					first_name: null,
					last_name: null,
					is_for_business: null,
					business_name: null,
					password: null,
					profile_image: null,
					password_confirmation: null,
					recaptcha_token: null,
					date_of_birth: null,
					role: null,
					phone: null,
					opType: 'create',
					step: 1,
					withFiles: true,
				},
				 customErrors: {
				date_of_birth: null,
				},
				componentsLoadingStatus: {
				ProfileImage: true,
				ImageUpload: true,
				},
			}
		},

		beforeMount() {
			this.recaptchaSiteKey = constants.RECAPTCHA_INVISIBLE_SITE_KEY
			this.formData.email = this.getEmailOrRedirect('/register')
			this.formData.first_name = this.userData.first_name
			this.formData.last_name = this.userData.last_name
			this.formData.business_name = this.userData.business_name
			this.formData.phone = this.userData.phone
			this.formData.date_of_birth = this.userData.date_of_birth

		    this.profile_image_url = this.userData.profile_image

			if (!_.isEmpty(this.formData.business_name)) {
				this.formData.is_for_business = true
			}

			this.loading = false
		},

		methods: {
			getEmailOrRedirect(redirectTo) {
				let email = null

				if (!_.isEmpty(this.userData.email)) {
					email = this.userData.email
				} else if (!_.isEmpty(localStorage.getItem('userEmail'))) {
					email = localStorage.getItem('userEmail')
				} else {
					// window.location = redirectTo
					return null
				}

				return email
			},

			imageUpdated(image_url, image) {
				this.profile_image_url = image_url
				this.formData.profile_image = image
			},

			submitForm() {
				this.loading = true

				if (!_.isEmpty(this.userData.email)) {
					this.formData.opType = 'update'
				}

				if (this.isFormInvalid) {
					this.customErrors.date_of_birth = 'This field is invalid'
					this.loading = false
					return false
				}

				this.formData.role = this.role

				// this.$refs.recaptcha.execute()
				this.$store.dispatch('registerStep', this.formData).then(() => {
					this.loading = false
					if (this.registerStepStatus === 'success') {
						this.$emit('formSubmitted')
						this.$store.dispatch('fetchAuthUser').then(() => {
							this.$store.dispatch('profile/fetchData').then(() => {
							this.loading = false
								let intendedCampaignUrl = localStorage.getItem('intendedCampaignUrl')
								if (!_.isEmpty(intendedCampaignUrl)) {
									localStorage.removeItem('intendedCampaignUrl')
									window.location = intendedCampaignUrl
								} else {
									this.$router.push({ name: 'profile' })
								}
							})
						})
					}

					this.$refs.recaptcha.reset();
				})
			},

			getDateOfBirthErrors () {
				if (this.registerStepErrors.has('date_of_birth')) {
					return this.registerStepErrors.get('date_of_birth')
				}
				return null
			},

			setDateOfBirthStatus (value) {
				this.isDateOfBirthValid = value
				this.customErrors.date = null
			},


			cancelAction() {
				window.location = '/register'
			},

			onCaptchaVerified: function (recaptchaToken) {
				this.formData.recaptcha_token = recaptchaToken
			},
			onCaptchaExpired: function () {
				// this.$refs.recaptcha.reset()
			},
			 componentLoading (componentName, value) {
				this.componentsLoadingStatus[componentName] = value
			},

		},

		computed: {
			...mapGetters([
				// 'registerStepStatus',
			]),

			registerStepStatus: {
				get() {
					return this.$store.getters['registerStepStatus'](this.formData.step)
				},
			},

			registerStepErrors: {
				get() {
					return this.$store.getters['registerStepErrors'](this.formData.step)
				},
			},

			hasErrors() {
				return this.registerStepStatus === 'failed'
			},

			unknownError() {
				if (this.hasErrors) {
					if (this.hasErrors && this.registerStepErrors.has('email')) {

						return 'This session has expired. Please login to continue.'

					} else if (!this.registerStepErrors.has('first_name') &&
						!this.registerStepErrors.has('last_name') &&
						!this.registerStepErrors.has('business_name') &&
						!this.registerStepErrors.has('recaptcha_token') &&
						!this.registerStepErrors.has('password') &&
						!this.registerStepErrors.has('phone') &&
						!this.registerStepErrors.has('date_of_birth') &&
						!this.registerStepErrors.has('profile_image')) {

						return 'Something went wrong. Please try again later.'
					}
				}

				return null
			},

			role() {
				if (!_.isEmpty(this.userRoles) && this.userRoles.includes('organizer')) {
					return 'organizer'
				}

				return 'donor'
			},

			isRegisteredUsingSocialMedia() {
				return !_.isEmpty(this.identities)
			},

			isFormInvalid() {
				return (_.isEmpty(this.formData.date_of_birth) || !this.isDateOfBirthValid)
									&& this.role === 'organizer'
									&& !this.formData.is_for_business
			}
		},

		watch: {
			loading(to, from) {
				this.$emit('componentLoading', 'stepComponent', to)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.svg.eye {
		margin-bottom: 5px;
	}
	.g-recaptcha {
		-webkit-transform: scale(0.86);
		-moz-transform: scale(0.86);
		-ms-transform: scale(0.86);
		-o-transform: scale(0.86);
		transform: scale(0.86);
		-webkit-transform-origin: 0 0;
		-moz-transform-origin: 0 0;
		-ms-transform-origin: 0 0;
		-o-transform-origin: 0 0;
		transform-origin: 0 0;
	}

	.is-for-business {
		font-family: Circular Std;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 18px;
		letter-spacing: -0.01em;
		color: #3E3E3E;
	}

	.profile-picture-label {
		font-family: Circular Std;
		font-style: normal;
		font-weight: 450;
		font-size: 14px;
		line-height: 18px;
		color: #3D3D3D;
	}

	.cancel-btn {
		height: 56px; 
		border: 2px solid #1DC071; 
		color: #1DC071; 
		background: white; 
		width: 100%; 
		font-family: Circular Std;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 16px;
		text-align: center;
		letter-spacing: 0.005em;
		color: #1DC071;
	}

	.save-btn {
		height: 56px; 
		color: white;  
		background : #1DC071; 
		width: 100%; 
		font-family: Circular Std;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 16px;
		text-align: center;
		letter-spacing: 0.005em;
		color: white;
	}

	.account-agreeement {
		font-family: Circular Std;
		font-style: normal;
		font-weight: 450;
		font-size: 14px;
		line-height: 22px;
		text-align: center;
		letter-spacing: -0.01em;
		color: #8C8C8C;
	}
	
	.profile-image-container {
		justify-content: start !important;
	}
</style>
